"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBusinessElectricity = function IconBusinessElectricity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11 12h2v2.305A6 6 0 0 1 16.36 13c2.998 0 5.523 2.779 5.636 5.864L22 19H22v24H9.295q-1.201-.93-2.276-2H11V14H5v-2h4v-2H7V8h4zm5.43 2.998C18.24 15 19.955 16.914 20 19h-7v-1.283l.024-.078a3.87 3.87 0 0 1 3.405-2.641M20 41h-7V21h7zm-2-10v-3h-1v3zm-2-3v3h-1v-3zm2 9v-3h-1v3zm-2-3v3h-1v-3zm-8-3V21H7v10zm18-18h16v23H29.76A3.76 3.76 0 0 1 26 32.24zm3.76 21H40V15H28v17.24c0 .923.711 1.68 1.616 1.754zM34 18v-1h-5v1zm1 1v1h-6v-1zm-.96 8.72L37 21.35l.23 4.78h1.59l-3.19 6.37v-4.78z",
    clipRule: "evenodd"
  })));
};

export { IconBusinessElectricity, IconBusinessElectricity as default };
